module.exports = __webpack_public_path__ + "img/mt4-icon1.0c2f4a8.png";